var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityChangingPlace = function SvgAccessibilityChangingPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 23.587,
    cy: 11.77,
    r: 1.493
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 8.424,
    cy: 7.565,
    r: 1.493
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M23.024 14.552a1.97 1.97 0 0 0 1.704-.238m.61 4.558a3.526 3.526 0 1 0 1.506 1.07"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M24.735 14.314a7.3 7.3 0 0 1 1.886 2.602c.467 1.075.43 2.15-.083 3.204q-.231.477-.555.895c-.184.234-.315.476-.599.598-.468.203-.9-.234-.841-.676.054-.401.361-.715.556-1.053a3.7 3.7 0 0 0 .445-1.11c.102-.511.017-1.04-.355-1.425l-.406 1.323m-3.867 2.024-.914-.07c-.039.082-1.208 2.747-1.355 3.072-.112.248-.217.547-.458.697a.62.62 0 0 1-.44.076.704.704 0 0 1-.517-.908l1.467-4.498a.33.33 0 0 1 .286-.226c.933-.089 1.794-.175 2.734-.259l1.305-4.028m6.296 11.242H.68m2.202-9.478H.78v2.02h16.408a.276.276 0 0 0 .275-.275v-1.47a.276.276 0 0 0-.275-.275h-3.5m-8.818.009h7.227m-5.631 2.172.166 6.686c.008.334.28.601.615.603h.507a.617.617 0 0 0 .614-.619v-6.681"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m10.249 18.497-.165 6.686a.617.617 0 0 1-.618.602H8.96a.617.617 0 0 1-.618-.618v-6.681m.083-8.071H6.937c-.732 0-1.4.415-1.725 1.07l-2.067 4.173a.617.617 0 0 0 .248.81l.388.222a.617.617 0 0 0 .839-.227l1.433-2.462.057 2.232m2.315-5.818h1.488a1.93 1.93 0 0 1 1.728 1.074l2.067 4.173a.617.617 0 0 1-.248.811l-.389.22a.617.617 0 0 1-.838-.227l-1.43-2.461-.056 2.232m2.531-8.005a8.16 8.16 0 0 1 3.564-1.135 1 1 0 0 1 .12 0 8 8 0 0 1 3.618 1.145"
  })), /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    width: 1,
    height: 3.02,
    x: 16.479,
    y: 4.211,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    width: 1,
    height: 1.425,
    x: 12.828,
    y: 7.15,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    width: 1,
    height: 1.425,
    x: 20.13,
    y: 7.15,
    rx: 0.5
  }))));
};
export default SvgAccessibilityChangingPlace;